import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { KeyRound } from "lucide-react";
import { Logo, scrollToId } from "@/components/Logo";
import { WhatsAppIcon, WHATSAPP_URL } from "@/components/WhatsApp";

const links = [
  { label: "Cómo funciona", target: "#como-funciona", testid: "nav-link-how" },
  { label: "Ventajas", target: "#ventajas", testid: "nav-link-why" },
  { label: "Preguntas", target: "#faq", testid: "nav-link-faq" },
];

export const Navbar = () => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    className="fixed top-0 inset-x-0 z-50 border-b border-industrial-700/60 bg-industrial-950/70 backdrop-blur-xl"
    data-testid="main-navbar"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
      <button onClick={() => scrollToId("#hero")} className="flex items-center gap-2.5 group" data-testid="nav-logo">
        <Logo className="w-11 h-11 -my-1 transition-transform duration-500 group-hover:scale-110" />
        <span className="hidden sm:inline font-display font-black text-lg sm:text-xl tracking-wider uppercase whitespace-nowrap">
          Piezas Aljarafe <span className="text-brand-orange">24H</span>
        </span>
      </button>
      <nav className="hidden md:flex items-center gap-8">
        {links.map((l) => (
          <button
            key={l.target}
            onClick={() => scrollToId(l.target)}
            data-testid={l.testid}
            className="font-mono text-xs uppercase tracking-widest text-slate-400 hover:text-brand-amber transition-colors"
          >
            {l.label}
          </button>
        ))}
      </nav>
      <div className="flex items-center gap-3">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-whatsapp-link"
          className="hidden lg:flex items-center gap-1.5 font-mono text-xs tracking-widest text-[#25D366] hover:text-white transition-colors"
        >
          <WhatsAppIcon className="w-4 h-4" /> 644 856 072
        </a>
        <Link
          to="/admin"
          data-testid="nav-admin-link"
          className="hidden sm:flex items-center gap-1.5 font-mono text-xs uppercase tracking-widest text-slate-500 hover:text-slate-200 transition-colors"
        >
          <KeyRound className="w-3.5 h-3.5" /> Taller
        </Link>
        <button
          onClick={() => scrollToId("#presupuesto")}
          data-testid="nav-cta-button"
          className="bg-brand-orange hover:bg-brand-amber text-white font-display font-bold uppercase tracking-wider text-sm px-5 py-2.5 rounded-sm transition-colors duration-300"
        >
          Pedir presupuesto
        </button>
      </div>
    </div>
  </motion.header>
);
